import { RefObject, useEffect } from "react";

export const useDisabledScroll = (
  ref: RefObject<HTMLDivElement>,
  isProgress: boolean,
) => {
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const eventDisable = (e: WheelEvent) => {
      e.preventDefault();
    };

    if (isProgress) {
      // eslint-disable-next-line no-param-reassign
      ref.current.onwheel = eventDisable;
    }

    if (!isProgress) {
      // eslint-disable-next-line no-param-reassign
      ref.current.onwheel = () => {};
    }
  }, [isProgress, ref]);
};
